<template>
  <div class="Keto">
      <app-header></app-header>
			<div class="page-wrapper">
				<div class="ketoCard">
					
				</div>

				<div
					class="modal fade"
					id="myModal"
					tabindex="-1"
					role="dialog"
					aria-labelledby="myModalLabel"
					aria-hidden="true"
				>
					<div class="modal-dialog" role="document">
						<div class="modal-content">
							<div class="modal-header">
								<h5 class="modal-title" id="myModalLabel">Diet Started</h5>
							</div>
							<div class="modal-body">You started the Keto diet. You can switch back to the standard diet on your profile page.</div>
							<div class="modal-footer">
								<button
									type="button"
									class="btn btn-success"
									data-dismiss="modal"
								>Okay</button>
							</div>
						</div>
					</div>
				</div>
				
				<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
					<div class="modal-dialog" role="document">
						<div class="modal-content">
							<div class="modal-header">
								<h5 class="modal-title" id="exampleModalLabel">Upgrade to VIP</h5>
							</div>
							<div class="modal-body">To start a diet you need to upgrade to VIP first. Would you like to check out our benefits?</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
								<button
									type="button"
									class="btn btn-success"
									data-dismiss="modal"
									@click="$router.push('/profile/upgrade')"
								>Okay</button>
							</div>
						</div>
					</div>
				</div>

				<div
        style="padding-bottom:30px;margin-left: 0px;margin-right: 0px;"
        class="panel panel-default card-view"
      >
        <div class="panel-heading">
          <div class="text-center">
            <h5 class="panel-title txt-light">Keto Diet</h5>
          </div>
          <div class="clearfix"></div>
        </div>
        <div id="collapse_1" class="panel-wrapper collapse in">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-md-offset-3">
									<p style="padding-top: 30px;">
										The Keto Calculator will help you find the exact amount of carbs, fat, and protein you need to reach your goal weight through the ketogenic diet, whether you want to lose, gain, or maintain your weight.
									</p>
									<p>
										A keto macro calculator helps you discover your unique needs, so you can:
										<ul style="list-style-type:disc; margin-left: 40px;">
											<li>Reach your weight loss or weight gain goals</li>
											<li>Easily enter and stay in ketosis</li>
											<li>Accurately track your macros throughout the day</li>
											<li>Stop guessing what and how much you should be eating</li>
											<li>Enjoy optimal health</li>
										</ul>
									</p>
								</div>
            </div>
          </div>
				<div class="container">
					<div class="row">	
						<div class="col-md-12 text-center" style="padding-top: 30px;">
								<a
									v-if="!$store.getters.user.vip_user"
									class="btn btn-nutri-green buttonKeto"
									data-target="#exampleModal"
									data-toggle="modal"
								>
									<span class="btn-text">Upgrade to start Keto calculator</span>
								</a>
								<a
									v-else
									class="btn btn-nutri-green buttonKeto"
									@click="recommendedIntakeCalculation"
								>
									<span class="btn-text">Start Keto calculator</span>
								</a>
							</div>	
					</div>	
				</div>
			</div>
		</div>
	</div>
	<app-footer></app-footer>
  </div>
</template>

<script>
	import API from "../../services/api.js";
    import AppFooter from '../../components/common/AppFooter.vue'
    import AppHeader from '../../components/common/AppHeader.vue'

	const api = new API();

	export default {
		data() {
			return {
			}
		},
		components: {
			AppHeader,
			AppFooter,
		},
		methods:{
			recommendedIntakeCalculation() {
				let profile = {
					"recommended_intake_calculation":"keto"
				} 
				api.updateProfile(profile).then(async response => {
					if (response.data.success) {
						api.me();		
					}
				});
				$('#myModal').modal('show');
    	},
		},
		mounted: function () {
	
		}
	}
</script>

<style>
.ketoCard{
	margin-top: -10px;
	background-image: url("https://images.pexels.com/photos/566566/pexels-photo-566566.jpeg");
	background-size: cover;
	height: 50vh;
	width: 100%;
}

.buttonKeto{
	width: 50%;
	margin-top: 4%;
}

.KetoDietButton{
	padding-bottom: 20px;
}


</style>



// WEBPACK FOOTER //
// src/views/Diet/Keto.vue